import React from 'react'
import { Button } from 'react-bootstrap'
import { Plus } from 'lucide-react'

export default function AddButton(props) {

    const { button_name, onClick } = props

    return (
        <>
            <Button type='button' size='sm' className='save_btn d-flex align-items-center' onClick={onClick}>
                <Plus size={18} className='' />{button_name}</Button>
        </>
    )
}
